import { Fragment } from "react";
import { jsx as _jsx } from "react/jsx-runtime";

import Avatar from "@mui/material/Avatar";
import {
  adjustAssetUrl,
  useConfigurationMeta,
} from "@plansoft-configuration-renderer/framework";

function ButtonUiImage(props) {
  const { baseUrl } = useConfigurationMeta();
  const { imageSrc, imageHeight, imageWidth, imageVariant } = props;
  if (!imageSrc) {
    return _jsx(Fragment, {});
  }
  const src = adjustAssetUrl(imageSrc, baseUrl);
  if (imageVariant != null) {
    return _jsx(Avatar, { src: src, variant: imageVariant });
  }
  return _jsx("img", { src: src, height: imageHeight, width: imageWidth });
}
export function useButtonUiImageIcons(props) {
  const { imagePosition } = props;
  const icon = _jsx(ButtonUiImage, Object.assign({}, props));
  const startIcon = imagePosition == "start" ? icon : undefined;
  const endIcon = imagePosition == "end" ? icon : undefined;
  return { startIcon, endIcon };
}
